<style scoped lang="scss">
@import "../common/public";

.mask {
  position: fixed;
  @include t_r_b_l();
  background-color: rgba(0, 0, 0, .5);
}

.main {
  overflow: hidden;
  width: 80%;
  border-radius: 4px;
  background-color: white;
}

ul {
  li {
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    width: 50%;
  }
}

dl {
  dd {
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    width: 100%;
  }
}

</style>

<template>
  <div class="mask flex flex-center flex-center-2" v-if="!hasRead">
    <div class="main" v-if="showMain">
      <h3 class="fs16 pt10 pb10 flex flex-center-2">温馨提示</h3>
      <section class="fs14 color_666 pl15 pr15">
        <p>感谢您信任并使用浙二好医生！</p>
        <p>浙二好医生非常重视您的隐私和个人信息保护。</p>
        <p>在您使用浙二好医生前，请认真阅读《隐私政策》，你同意并接受全部条款后方可开始使用浙二好医生。</p>
        <p>我们将尽全力保护您的个人信息及合法权益。</p>
      </section>
      <ol class="fs16 color_main flex flex-center-2 pt10 pb10"
          @click="$router.push({path:'/news/ysxy',query:{type:'',title:'隐私协议'}})">查看完整《隐私条款》
      </ol>
      <ul class="flex fs16 bt">
        <li class="color_red" @click="handler('no')">不同意</li>
        <li class="color_main bl" @click="handler('yes')">同意</li>
      </ul>
    </div>
    <div class="main" v-if="!showMain">
      <h3 class="fs16 pt10 pb10 flex flex-center-2">温馨提示</h3>
      <section class="fs14 color_666 pl15 pr15">
        <p>很抱歉，若您不同意相关协议，我们无法正常为您提供服务。</p>
        <p>我们会尽力保护您的个人信息及合法权益！</p>
      </section>
      <dl class="flex fs16 bt mt15">
        <dd class="color_main" @click="handler('repeat')">我知道了</dd>
      </dl>
    </div>
  </div>
</template>

<script>
import {hasReadYsxyCache} from "../lib/cache";
import {systemService} from "../services/system";
import {isBindMixin} from "@/lib/mixin";

export default {
  name: "v-wxts",
  mixins: [isBindMixin],
  data() {
    return {
      hasRead: true,
      showMain: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.checkRead();
    })

  },
  watch: {
    $route() {
      // this.checkRead();
    }
  },
  methods: {
    async handler(type) {
      if (type === 'yes') {
        await systemService.ysxySet('SYS');
        this.hasRead = true;
      } else if (type === 'repeat') {
        this.showMain = true;
      } else {
        this.showMain = false;
      }
      e
    },
    async checkRead() {
      const {path} = this.$route;
      if (this.requestLoading) {
        setTimeout(() => {
          this.checkRead();
        }, 20)
        return
      }
      Log('check read ysxy', path);
      if (path === '/bindRelativePhone') return;
      if (path === '/news/ysxy' || path === '/') this.hasRead = true;
      else {
        if (this.hasToken) {
          let hasReadServer;
          hasReadServer = await systemService.ysxyGet("SYS");
          this.hasRead = !hasReadServer || false;
        } else {
          this.hasRead = true;
        }
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/plugins/v-wxts.vue